export default class Modal {

    constructor( manager ) {
        this.manager = manager;
        this.modal = document.querySelector('.spark-container');
        this.open = this.__open.bind(this);
        this.close = this.__close.bind(this);
        this.eventListeners();

        this.loader = {
            element: this.modal.querySelector('.loading'),
            show() {
                this.element.style.display = 'block'
            },
            hide() {
                this.element.style.display = 'none'
            }
        };
    }

    getModal() {
        return this.modal
    }

    buttonListeners() {
        document
            .querySelectorAll('.cisco-button')
            .forEach(
                el => el.addEventListener('click', this.open)
            );
    }

    eventListeners() {
        this.modal
            .querySelector('.close-button')
            .addEventListener('click', this.close );
    }

    setFloatingButton() {
        this.floatingButton = document.querySelector('.cisco-modal-opener')
        this.floatingButton.classList.add( 'active' )
        this.floatingButton.addEventListener( 'click', this.open )
    }

    __open( ev ) {
        /**
         * rooms to delete
         * Y2lzY29zcGFyazovL3VzL1JPT00vOWViYTY2NTAtNzZmMi0xMWU5LWE4NTItMTdiZjgxNjA3NTg4
         */
        ev.preventDefault();
        this.manager.getForm().setAgent( ev.currentTarget.dataset.agent );
        this.show()
    }

    __close( ev ) {
        ev.preventDefault();
        this.hide()
    }

    show() {
        this.modal.style.display = 'flex'
    }

    hide() {
        this.modal.style.display = 'none'
    }

    startLoading() {
        this.loader.show();
    }

    stopLoading() {
        this.loader.hide()
    }

}